import { useEffect } from 'react';

export function useHideUserWayIcon() {
  const component: HTMLElement | null = document.querySelector(
    '.userway_buttons_wrapper'
  );

  useEffect(() => {
    if (component) component.style.display = 'none';

    return () => {
      if (component) component.style.display = 'flex';
    };
  }, []);

  return component;
}
